module.exports = __webpack_public_path__ + "img/BottomFlower.60d9d877.png";